<button 
  type="button" 
  class="btn btn-primary tour-button"
  (click)="onTourClick()"
  title="Iniciar tour guiado"
  aria-label="Iniciar tour guiado">
  <i class="fas fa-question-circle"></i>
</button>

